import { ThemeEvents } from '@theme/events';

const RC_PURCHASE_OPTION_GROUP = '.rc-purchase-option-group';
const SUBSCRIPTION_TEXT_SELECTOR = '[data-subscription-variant-only]';
const SYNC_DEBOUNCE_MS = 60;
const DOM_OBSERVER_MS = 25000;

/**
 * @param {ParentNode | null | undefined} root
 * @param {string} selector
 * @returns {Element | null}
 */
function querySelectorDeep(root, selector) {
  if (!root) return null;
  try {
    const direct = root.querySelector(selector);
    if (direct) return direct;
  } catch {
    return null;
  }
  const candidates = root.querySelectorAll('*');
  for (const el of candidates) {
    if (el.shadowRoot) {
      const found = querySelectorDeep(el.shadowRoot, selector);
      if (found) return found;
    }
  }
  return null;
}

/** Recharge n’affiche .rc-purchase-option-group que si la variante a un abo. */
function isVariantSubscriptionEligible() {
  return !!querySelectorDeep(document, RC_PURCHASE_OPTION_GROUP);
}

function syncSubscriptionTextVisibility() {
  const eligible = isVariantSubscriptionEligible();

  for (const element of document.querySelectorAll(SUBSCRIPTION_TEXT_SELECTOR)) {
    element.toggleAttribute('hidden', !eligible);
  }
}

let debounceTimer;
function scheduleSync() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(syncSubscriptionTextVisibility, SYNC_DEBOUNCE_MS);
}

/** Plusieurs passes après changement de variante (Recharge met à jour le widget en différé). */
function scheduleSyncAfterVariantChange() {
  scheduleSync();
  for (const delay of [100, 300, 600, 1200]) {
    setTimeout(scheduleSync, delay);
  }
}

let initialized = false;

function init() {
  if (initialized) return;
  initialized = true;

  syncSubscriptionTextVisibility();

  document.addEventListener(ThemeEvents.variantUpdate, scheduleSyncAfterVariantChange);

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), DOM_OBSERVER_MS);
}

init();
